import { Injectable } from '@angular/core';
import { TemplateSearchCar } from 'src/app/app.models';

@Injectable({
  providedIn: 'root'
})
export class DataSearchService {

  //Search car
  public address: any | null= "Côte d'Ivoire";
  public geometry: any | null= {location:{lat:()=>{return 7.665580628948325},lng:()=>{return -5.67440742909365}}};
  public markers: any | null;
  public Model: any | null;
  public diffDate: number | null;
  public templateSearchCar: TemplateSearchCar={
    address:"Côte d'Ivoire",
    dateEnd:new Date(Date.now()),
    dateStart:new Date(Date.now()),
    geometry:this.geometry,
    periodEnd: "Avant 12h",
    periodStart:"Après 12h"
  };

  
  //location car
  public idCar: number;

  //Latest Location Car
  public priceLocation: number;
  public isConnected: boolean = true
  // lat: any;
  // lng: any;
  // isRentingMap: boolean;
  

  //Home Map
  public lat: number;
  public lng: number;
  public isRentingMap: boolean = false;


  //Condition of period search
  public periodCondition(val: string | null): string | null {

    if(val == null) {

      return null;

    } else {

      if(val == 'Après 12h') {

        return 'Ap 12h';
  
      } else {
  
        return 'Av 12h'
      }

    }
    
    
  }
  
}
